import { action } from 'satcheljs';
import type { AccountSource } from '../store/schema/AccountSourceList';

export interface ON_PRE_COPRINCIPAL_ACCOUNT_REMOVEDActionMessage {
    removedAccount: AccountSource;
}
const defaultExport: (
    removedAccount: AccountSource
) => ON_PRE_COPRINCIPAL_ACCOUNT_REMOVEDActionMessage = action(
    'ON_PRE_COPRINCIPAL_ACCOUNT_REMOVED',
    (removedAccount: AccountSource): ON_PRE_COPRINCIPAL_ACCOUNT_REMOVEDActionMessage => ({
        removedAccount,
    })
);
export default defaultExport;
